export function getProductArchiveCounterComponent(idBase) {
    return {
        name: 'ProductArchiveCounter',
        props: {
            total: {
                type: Number,
                required: true,
            },
            perPage: {
                type: Number,
                required: true,
            },
            current: {
                type: Number,
                required: true,
            },
            singleText: {
                type: String,
                required: true,
            },
            pluralText: {
                type: String,
                required: true,
            },
        },
        computed: {
            first() {
                return this.perPage * this.current - this.perPage + 1;
            },
            last() {
                return Math.min(this.total, this.perPage * this.current);
            },
            counterText() {
                const text = this.total === 1 ? this.singleText : this.pluralText;

                return text.replace('%d', this.total);
            },
        },
        template: `#${idBase}-counter`,
    };
}
